<template>
  <div class="book-post">
   
    <div>
    <BookHeader 
      :id="book.id"
      :title="book.title" 
      :bookCover="book.coverImage"
      :authorName="book.author.name"
      :tags="book.tags"
    />

    <AuthorInfo style="display: flex;gap: 10px;"
      :authorName="book.author.name"
      :authorImage="book.author.image"
      :authorDescription="book.author.description"
    />
    </div>
    
    <div class="relative">
    <!-- Skeleton loader -->
    <div 
      v-if="isLoading"
      class="skeleton-wrapper"
    >
      <div class="skeleton-content">
        <div class="skeleton-circle"></div>
        <div class="skeleton-lines">
          <div class="skeleton-line-long"></div>
          <div class="skeleton-line-short"></div>
        </div>
      </div>
    </div>

    <!-- Actual SoundCloud iframe -->
    <div 
      :class="{ 'invisible': isLoading, 'visible': !isLoading }"
      v-html="book.audioLink"
      ref="soundCloudContainer"
      style="margin: 15px;"
    ></div>

    <!-- @load="handleIframeLoad" -->

    <!-- <div v-html="book.audioLink" style="margin: 15px;"> -->

    <!-- </div> -->

    </div>
    
    <section class="book-summary">
      <h2 @click="showPitch=!showPitch" style="color: #ffffffe5;"><i class="el-icon-s-promotion" style="color: #ffbf5e;"></i>  Pitch</h2>
      <p v-if="showPitch" class="takeaway-item" 
      v-html="book.summary"></p>
    </section>
    

    <section class="key-takeaways">
      <h2 @click="showTakeAways=!showTakeAways" style="color: #ffffffe5;"><i class="el-icon-s-promotion" style="color: #ffbf5e;"></i>  Key Takeaways</h2>
      <div v-if="showTakeAways">
        <div 
        v-for="(takeaway, index) in book.keyTakeaways" 
        :key="index" 
        class="takeaway-item"
      >
        <h3 class="takeaway-title">{{ index+1 }}- {{ takeaway.title }}</h3>
        <p 
          class="takeaway-content" 
          v-html="takeaway.content"
        ></p>
      </div>
      </div>
      
    </section>

  </div>
</template>

<script>
import BookHeader from './BookHeader.vue'
import AuthorInfo from './AuthorInfo.vue'

export default {
  name: 'BookPost',
  components: {
    BookHeader,
    AuthorInfo
  },
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  data() {
      return {
        showPitch: false,
        showTakeAways: false,
        isLoading: true
      };
  },
  watch: {
    'book.audioLink': {
      handler() {
        this.isLoading = true;
        this.$nextTick(() => {
          this.setupIframeLoadDetection();
        });
      },
      immediate: true
    }
  },
  methods: {
    // handleIframeLoad() {
    //   this.isLoading = false;
    // }
    setupIframeLoadDetection() {
      setTimeout(() => {
        const iframe = this.$refs.soundCloudContainer?.querySelector('iframe');
        if (iframe) {
          iframe.onload = () => {
            this.isLoading = false;
          };
          // Fallback in case onload doesn't trigger
          setTimeout(() => {
            this.isLoading = false;
          }, 5000);
        }
      }, 100);
    }
  },
  mounted() {
    this.setupIframeLoadDetection();
  }
}
</script>

<style scoped>
.key-takeaways {
  margin-bottom: 0px;
}

.takeaway-item {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.takeaway-title {
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.takeaway-content {
  line-height: 1.6;
}

/* Additional styling for inline elements */
.takeaway-content strong {
  font-weight: bold;
}

.takeaway-content em {
  font-style: italic;
}

.skeleton-wrapper {
  width: 100%;
  height: 100px;
  background-color: #f3f3f3;
  border-radius: 4px;
  margin: 15px 0;
}

.skeleton-content {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 15px;
}

.skeleton-circle {
  width: 48px;
  height: 48px;
  background-color: #e0e0e0;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

.skeleton-lines {
  margin-left: 15px;
  flex: 1;
}

.skeleton-line-long {
  height: 16px;
  width: 75%;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
  animation: pulse 1.5s infinite;
}

.skeleton-line-short {
  height: 12px;
  width: 50%;
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.invisible {
  position: absolute;
  visibility: hidden;
}

.visible {
  position: relative;
  visibility: visible;
}
</style>